import { render, staticRenderFns } from "./EditIssueStatus.vue?vue&type=template&id=7ba839a9&"
import script from "./EditIssueStatus.vue?vue&type=script&lang=js&"
export * from "./EditIssueStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports